import { useExperimentContext } from '../useExperimentContext.js';

function useExperimentLogging() {
    var loggedExposures = [];
    var context = useExperimentContext();
    function logExposure(props) {
        var exposureType = props.exposureType;
        var hasLoggedExposure = loggedExposures.includes(exposureType);
        if (hasLoggedExposure) {
            return;
        }
        loggedExposures.push(exposureType);
        context.log(props);
    }
    return {
        logExposure: logExposure,
    };
}

export { useExperimentLogging };
